export default __webpack_public_path__ + "static/media/angle-double-right.ade1b295.svg";